<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            :title="switchable?'选择收货地址':'我的收货地址'"
            left-arrow
            @click-left="$router.go(-1)"
        />
        <van-address-list
            v-model="chosenAddressId"
            :list="list"
            :switchable="switchable"
            default-tag-text="默认"
            @add="$router.push('/my_address_edit?id=0')"
            @select="onSelect"
            @edit="onEdit"
        />
    </div>
</template>

<script>
import { AddressList } from 'vant';
import eventBus from "@/store/eventbus";
import http from "@/utils/http";

export default {
    name: "MyAddress",
    data() {
        return {
            chosenAddressId: 0,
            list: [],
            switchable: false
        };
    },
    created() {
        if(this.$route.query.select) {
            this.switchable = true
        }
        this.loadList();
    },
    methods: {
        onEdit(item, index) {
            this.$router.push('/my_address_edit?id='+item.id);
            localStorage.setItem('my_address_edit', JSON.stringify(item));
            // Toast('编辑地址:' + index);
        },
        onSelect(item, index) {
            item.mobile = item.tel;
            item.addressCode = item.areaCode;
            var newItem = JSON.parse(JSON.stringify(item));
            newItem.address = newItem.address2;
            eventBus.$emit('addressSelected', newItem);
            // console.log(item)
            this.$router.go(-1)
        },
        loadList() {
            http.get('/api/personal/list_addresses').then(res => {
                this.list = res.data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        tel: item.mobile,
                        addressCodeName:item.addressCodeName,
                        address: item.addressCodeName+item.address,
                        address2: item.address,
                        areaCode: item.addressCode,
                        isDefault: item.defaultAddress
                    }
                });
                // if(this.list.length > 0) {
                //     this.chosenAddressId = this.list[0].id;
                // }
            });
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .van-button--danger {
    background-color: var(--color);
    border-color: var(--color);
}
/deep/.van-address-item .van-radio__icon--checked .van-icon {
    background-color: var(--color);
    border-color: var(--color);
}
/deep/.van-tag--danger {
    background-color: var(--color);
}
</style>